import { API_API_BASE } from "./MainSettings";

export const API_BASE = API_API_BASE;